<template>
  <div class="grading-actions">
    <div class="actions-left">
      <button
        @click="$emit('save')"
        class="action-btn save-btn"
        :class="{ saving: isSaving }"
        :disabled="isSaving"
      >
        <span v-if="isSaving" class="btn-loading"></span>
        {{ isSaving ? 'Saving...' : 'Save' }}
      </button>
      
      <button
        v-if="hasUnsavedChanges"
        class="action-btn changes-indicator"
        disabled
      >
        Unsaved Changes
      </button>
    </div>
    
    <div class="actions-right">
      <button
        @click="$emit('complete')"
        class="action-btn complete-btn"
        :class="{ completable: completionPercentage >= 80 }"
        :disabled="completionPercentage < 80"
      >
        Mark Complete
      </button>
      
      <button
        @click="$emit('next')"
        class="action-btn next-btn"
      >
        Next Candidate →
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    completionPercentage: Number,
    hasUnsavedChanges: Boolean,
    isSaving: Boolean
  }
}
</script>

<style scoped>
.grading-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background: white;
  border-top: 1px solid #e9ecef;
  box-shadow: 0 -2px 4px rgba(0,0,0,0.1);
}

.actions-left,
.actions-right {
  display: flex;
  gap: 10px;
  align-items: center;
}

.action-btn {
  padding: 10px 20px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  background: #f8f9fa;
  color: #495057;
  cursor: pointer;
  font-size: 0.9em;
  font-weight: 500;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.action-btn:hover:not(:disabled) {
  background: #e9ecef;
  border-color: #adb5bd;
}

.action-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.save-btn {
  background: #28a745;
  border-color: #28a745;
  color: white;
}

.save-btn:hover:not(:disabled) {
  background: #218838;
  border-color: #1e7e34;
}

.save-btn.saving {
  background: #ffc107;
  border-color: #ffc107;
  color: #212529;
}

.changes-indicator {
  background: #fff3cd;
  border-color: #ffeaa7;
  color: #856404;
}

.complete-btn {
  background: #6c757d;
  border-color: #6c757d;
  color: white;
}

.complete-btn.completable {
  background: #17a2b8;
  border-color: #17a2b8;
}

.complete-btn.completable:hover:not(:disabled) {
  background: #138496;
  border-color: #117a8b;
}

.next-btn {
  background: #007bff;
  border-color: #007bff;
  color: white;
}

.next-btn:hover:not(:disabled) {
  background: #0056b3;
  border-color: #004085;
}

.btn-loading {
  width: 16px;
  height: 16px;
  border: 2px solid transparent;
  border-top: 2px solid currentColor;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>